import { Sections } from 'src/constant';

export const AppBarLinks = [
	Sections.AboutMe,
	Sections.Skills,
	Sections.Projects,
	Sections.Contact,
];
